"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveStreamRequest = void 0;
var dvr_1 = require("../metadata/dvr");
var geo_1 = require("../metadata/geo");
var LiveStreamRequest = /** @class */ (function () {
    function LiveStreamRequest(data) {
        this.protocol = null;
        this.maxStreamingSec = null;
        this.geo = null;
        this.connectTimeout = null;
        this.reconnectTimeout = null;
        this.streamType = null;
        this.dvr = null;
        this.stateNotification = null;
        this.protocol = data.protocol;
        this.maxStreamingSec = data.maxStreamingSec;
        this.geo = new geo_1.Geo(data.geo);
        this.connectTimeout = data.connectTimeout;
        this.reconnectTimeout = data.reconnectTimeout;
        this.streamType = data.streamType || null;
        this.dvr = new dvr_1.Dvr(data.dvr);
        this.stateNotification = data.stateNotification || null;
    }
    return LiveStreamRequest;
}());
exports.LiveStreamRequest = LiveStreamRequest;
//# sourceMappingURL=live-stream-request.js.map